import type { TireStatus } from '../../types';
import { getStatusColor, getStatusLabel, cn } from '../../lib/utils';

interface BadgeProps {
  status: TireStatus;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const Badge = ({ status, className, size = 'md' }: BadgeProps) => {
  const colors = getStatusColor(status);
  const label = getStatusLabel(status);

  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-3 py-1',
    lg: 'text-base px-4 py-1.5',
  };

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full font-medium border',
        colors.bg,
        colors.text,
        colors.border,
        sizeClasses[size],
        className
      )}
    >
      {label}
    </span>
  );
};
